<div class="container" style="border-color: #E0E0E0; border-style: solid; border-width: thin">
  <div class="post" style="background-color: #F8F8F8;">
    <div class="header_post">
      <img src="{{cardImage}}" alt="">
    </div>

    <div class="body_post">
      <div class="post_content">

        <h1>{{title}}</h1>
        <p>{{subTitle}}</p>
        <p>{{subTitle2}}</p>
        <!-- <p>IMO: 9110975     -     Container Ship</p> -->

        <div class="row" style="font-size:x-small; margin-top: 10px;">
          <div class="col-sm-6"><b>{{field1}}</b>{{fieldContent1}}</div>
          <div class="col-sm-6"><b>{{field2}}</b>{{fieldContent2}}</div>
        </div>
        <div class="row" style="font-size:x-small">
          <div class="col-sm-6"><b>{{field3}}</b>{{fieldContent3}}</div>
          <div class="col-sm-6"><b>{{field4}}</b>{{fieldContent4}}</div>
        </div>
        <div class="row" style="font-size: x-small;">
          <div class="col-sm-6"><b>{{field5}}</b>{{fieldContent5}}</div>
          <div class="col-sm-6"><b>{{field6}}</b>{{fieldContent6}}</div>
        </div>
        <div class="row" style="font-size: x-small;">
          <div class="col-sm-6"><b>{{field7}}</b>{{fieldContent7}}</div>
          <div class="col-sm-6"><b>{{field8}}</b>{{fieldContent8}}</div>
        </div>
        <div class="row" style="font-size: x-small;">
          <div class="col-sm-6"><b>{{field9}}</b>{{fieldContent9}}</div>
          <div class="col-sm-6"><b>{{field10}}</b>{{fieldContent10}}</div>
        </div>

        <div *ngIf="eventName!==undefined" class="card-body">
          <ul class="timeline">
            <li>
              <div class="timeline-badge success"><i class="fa fa-check"></i></div>
              <div class="timeline-panel">
                <div class="timeline-heading">
                  <h4 class="timeline-title" style="font-size: 11px !important;">
                    {{eventName}}
                  </h4>
                </div>
                <div class="timeline-body" style="text-transform: uppercase;">
                  <!-- <p style="font-size: 10px !important;">sdfdsds</p> -->
                  <!-- {{ setInverted() }} -->
                </div>
              </div>
            </li>
          </ul>
        </div>

      </div>




    </div>
  </div>


  <!-- <a href="https://youtu.be/Izm8SutcQv4" target="_blank"><footer>
  <div class="texto">
      <span>
          <i class="fab fa-youtube"></i>
           watch on youtube</span>
  </div>
</footer>
 </a> -->
